export default __webpack_public_path__ + "css/userPendingAccounts.bundle.css";